export const MOCK_URL = Object.freeze({
  MAPPING_LIST :`/mapping/list`,
  MAPPING_COUNT :`/mapping/count`,
  MAPPING_INITIATE:`/mapping/initiate`
})